<mat-form-field>
  <mat-label>{{ roleName }}</mat-label>
  <input matInput [matAutocomplete]="autocomplete" [formControl]="control" />
  @if (
    !control.disabled &&
    control.value &&
    control.value !== '' &&
    !(personSearch.loading$ | async)
    ) {
    <button
      mat-icon-button
      matSuffix
      color="warn"
      matTooltip="Clear selection"
      (click)="control.setValue(null)">
      <mat-icon>close</mat-icon>
    </button>
  }
  @if (!control.disabled && (personSearch.loading$ | async)) {
    <mat-spinner
      mode="indeterminate"
      matSuffix
      diameter="16"
    ></mat-spinner>
  }
  <mat-autocomplete #autocomplete="matAutocomplete" [displayWith]="displayFn">
    @for (person of personSearch.people$ | async; track person) {
      <mat-option
        [value]="person">
        {{ person.name }}
      </mat-option>
    }
  </mat-autocomplete>
  <mat-error>{{ roleName }} is required</mat-error>
</mat-form-field>
